package team.platforma.materialextension.moc_data

import team.platforma.multiplatform_material_extension.ui.drop_down.model.ListItem


class MokOrganizations {

    private val mokTitles = listOf(
        "Министерство внутренних дел Российской Федерации (МВД России)",
        "Министерство Российской Федерации по делам гражданской обороны, чрезвычайным ситуациям и ликвидации последствий стихийных бедствий (МЧС России)",
        "Министерство иностранных дел Российской Федерации (МИД России)",
        "Федеральное агентство по делам Содружества Независимых Государств, соотечественников, проживающих за рубежом, и по международному гуманитарному сотрудничеству (Россотрудничество)",
        "Министерство обороны Российской Федерации (Минобороны России)",
        "Федеральная служба по техническому и экспортному контролю (ФСТЭК России)",
        "Министерство юстиции Российской Федерации (Минюст России)",
        "Министерство здравоохранения Российской Федерации (Минздрав России)",
        "Федеральная служба по надзору в сфере здравоохранения (Росздравнадзор)",
        "Министерство культуры Российской Федерации (Минкультуры России)",
        "Министерство природных ресурсов и экологии Российской Федерации (Минприроды России)",
        "Федеральная служба по гидрометеорологии и мониторингу окружающей среды (Росгидромет)",
        "Федеральная служба по надзору в сфере природопользования (Росприроднадзор)",
        "Федеральное агентство водных ресурсов (Росводресурсы)",
        "Федеральное агентство лесного хозяйства (Рослесхоз)",
        "Федеральное агентство по недропользованию (Роснедра)",
        "Министерство труда и социальной защиты Российской Федерации (Минтруд России)",
        "Федеральная служба по труду и занятости (Роструд)",
        "Министерство финансов Российской Федерации (Минфин России)",
        "Федеральная налоговая служба (ФНС России)",
        "Федеральная пробирная палата",
        "Федеральная служба по контролю за алкогольным и табачным рынками (Росалкогольтабакконтроль)",
        "Федеральная таможенная служба (ФТС России)",
        "Федеральное казначейство (Казначейство России)",
        "Федеральное агентство по управлению государственным имуществом (Росимущество)",
        "Министерство цифрового развития, связи и массовых коммуникаций Российской Федерации (Минцифры России)",
        "Федеральная служба по надзору в сфере связи, информационных технологий и массовых коммуникаций (Роскомнадзор)",
        "Министерство экономического развития Российской Федерации (Минэкономразвития России)",
        "Федеральная служба по аккредитации (Росаккредитация)",
        "Федеральная служба государственной статистики (Росстат)",
        "Федеральная служба по интеллектуальной собственности (Роспатент)",
        "Служба внешней разведки Российской Федерации (СВР России)",
        "Федеральная служба безопасности Российской Федерации (ФСБ России)",
        "Федеральная служба войск национальной гвардии Российской Федерации (Росгвардия)",
        "Федеральная служба охраны Российской Федерации (ФСО России)",
        "Федеральная служба по военно-техническому сотрудничеству (ФСВТС России)",
        "Федеральная служба по финансовому мониторингу (Росфинмониторинг)",
        "Федеральное архивное агентство (Росархив)",
        "Главное управление специальных программ Президента Российской Федерации (ГУСП)",
        "Управление делами Президента Российской Федерации",
        "Государственная фельдъегерская служба Российской Федерации (ГФС России)",
        "Федеральная антимонопольная служба (ФАС России)",
        "Федеральная служба государственной регистрации, кадастра и картографии (Росреестр)",
        "Федеральная служба по надзору в сфере защиты прав потребителей и благополучия человека (Роспотребнадзор)",
        "Федеральная служба по надзору в сфере образования и науки (Рособрнадзор)",
        "Федеральная служба по экологическому, технологическому и атомному надзору (Ростехнадзор)",
        "Федеральное агентство по государственным резервам (Росрезерв)",
        "Федеральное медико-биологическое агентство (ФМБА России)",
        "Федеральное агентство по делам молодёжи (Росмолодёжь)",
        "Федеральное агентство по делам национальностей (ФАДН России)",
        "Государственная корпорация по атомной энергии «Росатом»",
        "Государственная корпорация по космической деятельности «Роскосмос»",
        "Федеральный фонд обязательного медицинского страхования",
        "Фонд пенсионного и социального страхования"

    )

    private val mocList = mutableListOf<ListItem>()

    init {
        for (i in mokTitles.indices) {
            mocList.add(ListItem(id = i.toLong(), title = mokTitles[i]) )
        }
    }


    fun startList() = mocList.slice(0..10)


    fun searchOrganization(search: String) : List<ListItem> = mocList.filter {
        it.title.contains(search, ignoreCase = true)
    }
}

